import { apiAction } from 'actions/application'
import { createAction } from 'actions/utils'
import { getReleaseNotes, postReleaseNote } from 'services/releaseNotes'

export const RELEASE_NOTES_REQUEST = 'RELEASE_NOTES_REQUEST'
export const RELEASE_NOTES_SUCCESS = 'RELEASE_NOTES_SUCCESS'
export const RELEASE_NOTES_FAILURE = 'RELEASE_NOTES_FAILURE'
export const fetchReleaseNotes = (currentVersion) =>
  apiAction({
    asyncFn: getReleaseNotes,
    args: { currentVersion },
    id: RELEASE_NOTES_REQUEST,
    requestActionType: RELEASE_NOTES_REQUEST,
    successActionType: RELEASE_NOTES_SUCCESS,
    failureActionType: RELEASE_NOTES_FAILURE,
  })

export const SAVE_RELEASE_NOTE_REQUEST = 'SAVE_RELEASE_NOTE_REQUEST'
export const SAVE_RELEASE_NOTE_SUCCESS = 'SAVE_RELEASE_NOTE_SUCCESS'
export const SAVE_RELEASE_NOTE_FAILURE = 'SAVE_RELEASE_NOTE_FAILURE'
export const saveReleaseNote = (requestBody) =>
  apiAction({
    asyncFn: postReleaseNote,
    args: { requestBody },
    id: SAVE_RELEASE_NOTE_REQUEST,
    requestActionType: SAVE_RELEASE_NOTE_REQUEST,
    successActionType: SAVE_RELEASE_NOTE_SUCCESS,
    failureActionType: SAVE_RELEASE_NOTE_FAILURE,
  })

export const ADD_RELEASE_VERSION = 'ADD_RELEASE_VERSION'
export const addReleaseVersion = createAction(ADD_RELEASE_VERSION, ['version'])
